import { Colaborador } from '@/store/catalogos/colaborador';
import { properties } from '@/utils/properties';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class CatalogoColaboradorService {
  private readonly baseUrl = properties.URL_CATALOGOS + 'colaboradores';

  constructor(private http: HttpClient) { }

  // Obtener todos los colaboradores
  getAll(): Observable<Colaborador[]> {
    return this.http.get<Colaborador[]>(this.baseUrl, httpOptions);
  }

  // Crear un nuevo colaborador
  create(colaborador: Colaborador): Observable<Colaborador> {
    return this.http.post<Colaborador>(this.baseUrl, colaborador, httpOptions);
  }

  // Actualizar un colaborador existente
  update(colaborador: Colaborador): Observable<Colaborador> {
    return this.http.put<Colaborador>(`${this.baseUrl}`, colaborador, httpOptions);
  }

  // Cambiar el estatus de un colaborador
  updateStatus(idColaborador: number): Observable<Colaborador> {
    return this.http.put<Colaborador>(`${this.baseUrl}/estatus/${idColaborador}`, httpOptions);
  }

  uploadFoto(id: number, file: File): Observable<string> {
    const formData = new FormData();
    formData.append('foto', file);
    return this.http.post(`${this.baseUrl}/${id}/foto`, formData, { responseType: 'text' });
  }

  getFoto(id: number): Observable<string> {
    return this.http.get(`${this.baseUrl}/colaborador/${id}/foto`, { responseType: 'text' });
  }
}
